var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIconCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Trophy--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Trophy Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy--reward-rating-trophy-social-award-media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M0 0.749908c0 -0.414213 0.335786 -0.7499995527 0.75 -0.7499995527h2.88462c0.01876 0 0.03737 0.0006892797 0.05579 0.0020439027h6.62089c0.0179 -0.001297666 0.036 -0.0019530653 0.0541 -0.0019530653H13.25c0.4142 0 0.75 0.3357867153 0.75 0.7499997153V3.63499c0 1.85926 -1.396 3.39246 -3.1971 3.60855 -0.4474 1.3692 -1.61369 2.41325 -3.0529 2.68626V12.5h2.6154c0.4142 0 0.75 0.3358 0.75 0.75s-0.3358 0.75 -0.75 0.75H7.02626c-0.00872 0.0003 -0.01747 0.0005 -0.02626 0.0005s-0.01754 -0.0002 -0.02626 -0.0005H3.63461c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75H6.25V9.9298c-1.43921 -0.27301 -2.60549 -1.31707 -3.05293 -2.68626C1.39604 7.02745 0 5.49425 0 3.63499V0.749908ZM2.88462 5.63413V1.49991H1.5v2.13508c0 0.91499 0.57569 1.69552 1.38462 1.99914ZM11.1154 1.5v4.13413C11.9243 5.33051 12.5 4.54998 12.5 3.63499V1.5h-1.3846Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIconCurrent);
export default __webpack_public_path__ + "static/media/trophy-icon-current.80e8a7b786dcf9cdf715b343ce04ef78.svg";
export { ForwardRef as ReactComponent };